import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EffectsModule } from '@ngrx/effects'
import { effects } from './effects'

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature(effects),
  ],
  providers: [],
})
export class PoUploadStoreModule {}
